<script lang="ts">
	interface Props {
		value: number
		showProgress?: boolean
	}

	let { value = 0, showProgress = false }: Props = $props()
</script>

<div class="progress-container">
	<div class="progress-bar">
		<div class="progress-fill" style="width: {value}%"></div>
	</div>
	{#if showProgress}
		<span class="progress-indicator">{Math.ceil(value)}%</span>
	{/if}
</div>

<style>
	.progress-container {
		@apply flex items-center w-full max-w-full min-w-24;
	}

	.progress-bar {
		@apply flex-1 h-2 bg-[#00498011] rounded-full overflow-hidden;
	}

	.progress-fill {
		@apply h-full bg-[#007ACC] rounded-full;
		transition: width 0.3s ease-out;
	}

	.progress-indicator {
		@apply flex items-center min-w-8 text-sm text-[#001D33B2] pl-4;
	}
</style>
